import {
  RiCloudLine,
  RiPriceTag3Line,
  RiStore3Line,
  RiTranslate2,
  RiDatabase2Line,
} from "react-icons/ri";
import SectionNavigation from "../../../Utility/SectionNavigation";

const navItems = [
  { id: "saas_module", label: "SaaS module", icon: RiCloudLine },
  { id: "client_tag", label: "Client tags", icon: RiPriceTag3Line },
  { id: "vendor_tag", label: "Vendor tags", icon: RiStore3Line },
  { id: "language", label: "Script Language", icon: RiTranslate2 },
  { id: "db_language", label: "Database Languages", icon: RiDatabase2Line },
];

/**
 * Horizontal tabs for Settings → System lists (same UX pattern as Work Items).
 */
export default function SystemListsNavigation({ activeTab, onTabChange }) {
  return (
    <SectionNavigation
      items={navItems}
      activeTab={activeTab}
      onTabChange={onTabChange}
      iconSize={16}
    />
  );
}
